import request from '@/service/index'
import postJson from "@/service/postJson"
export const getOrder = (params) => {
  return request({
    url: 'order/orderBase/list',
    params,
    method: 'get'
  })
}

export const getOrderDetail = (orderId) => {
    return request({
        url: 'order/orderBase/'+ orderId,
        method: 'get'
    })
}

export const sendOrder = (data) => {
    return postJson({
        url: 'order/orderBase/shipToOrder',
        method: 'post',
        data,
        headers:{'Content-Type': 'application/json' }
    })
}

/**
 * 多商品退款
 */
export const refundOrder = (data) => {
    return postJson({
        url: 'order/orderService/addOrderProductService',
        data,
        method: 'post',
        headers:{'Content-Type': 'application/json' }
    })
}

/**
 * 批量获取打印订单列表
 */
export const batchGetPrintOrder = (params) => {
    return request({
        url: 'order/orderBase/batchGetPrintOrder',
        params,
        method: 'get'
    })
}

/**
 * 批量发货订单（修改订单状态为待收货）
 */
export const batchUpdateOrderStatus = (data) => {
    return request({
        url: 'order/orderBase/batchUpdateOrderStatus',
        data,
        method: 'post'
    })
}

/**
 * 查询订单数量统计
 */
export const getOrderCountNum = (params) => {
    return request({
        url: 'order/orderBase/countOrderNum',
        params,
        method: 'get'
    })
}

export const scanWechatCodePay = (params) => {
    return request({
        url: 'order/weChatPay/scanWechatCodePay',
        params,
        method: 'get'
    })
}

export const createOrderByPos = (data) => {
    return postJson({
        url: 'order/orderBase/createOrderByPos',
        data,
        method: 'post',
        headers:{'Content-Type': 'application/json' }
    })
}

//预结算订单商品
export const settlementOrderItem = data => {
    return postJson({
        url: 'order/orderShopcarDetail/preSettlementShopCarV2',
        data,
        method: 'post',
        headers:{'Content-Type': 'application/json' }
    })

};


export const scanAliCodePay = (data) => {
    return request({
        url: 'order/aliPay/scanAliCodePay',
        data,
        method: 'get'
    })
}
export const doUserAccountPay = (data) => {
    return request({
        url: 'order/orderUserAccountDeposit/doUserAccountPay',
        data,
        method: 'get'
    })
}

export const refundOrderByPos = (data) => {
    return request({
        url: 'order/orderBase/refundOrderByPos',
        data,
        method: 'get'
    })
}


export const printOrderReceipt = (params) => {
    return request({
        url: 'order/orderBase/printReceipt',
        params,
        method: 'get'
    })
}




// WEBPACK FOOTER //
// ./src/api/order.js